import Gif from '../../assets/top.gif'
import Logo from '../../assets/ic.png'
import { Link } from 'react-router-dom'
import { IoPersonOutline, IoClose } from "react-icons/io5";
import { FaAngleDown, FaRegHeart } from "react-icons/fa6";
import { FiShoppingCart, FiLogIn } from "react-icons/fi";
import { BsBox2 } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { useState } from 'react';

const Top = () => {

    const [showAccountDropDown, setShowAccountDropDown] = useState(false)
    const [showSearch, setShowSearch] = useState(false)

    const toggleShowAccountDropDown = () => {
        setShowAccountDropDown(!showAccountDropDown)
    }

    const toggleShowSearch = () => {
        setShowSearch(!showSearch)
    }

    return (
        <>
            <a href='#/' className=" block w-full h-[60px] bg-black overflow-hidden">
                <img src={Gif} className=' h-full m-auto' alt="" />
            </a>
            {/* Search for small screen */}
            <div className={`${showSearch ? " top-0 visible opacity-100" : " -top-10 invisible opacity-0"} transition-all duration-500 md:hidden absolute w-full py-10 z-20 px-4 bg-white/90 backdrop-blur-sm shadow-md`}>
                <div onClick={toggleShowSearch} className=" absolute top-4 right-4 text-2xl hover:text-red-500 cursor-pointer"><IoClose /></div>
                <form action="" className=' w-full flex items-center justify-center'>
                    <input type="text" name="search" id="" placeholder='Search product' className=' w-full max-w-[300px] h-[40px] rounded-l-full rounded-r-none' />
                    <button className=' bg-tripstore-black text-white h-[40px] rounded-l-none rounded-r-full' type="submit"><FaSearch /></button>
                </form>
            </div>
            <div className=" container py-4">
                <div className=" flex justify-between items-center">
                    <Link to={'/'}>
                        <div className=" h-[60px]">
                            <img src={Logo} className=' h-full' alt="" />
                        </div>
                    </Link>
                    <div className=" hidden md:block flex-1 px-8">
                        {/* Search for big screen */}
                        <form action="" className=' w-full flex items-center justify-center'>
                            <input type="text" name="search" id="" placeholder='Search product' className=' w-full max-w-[300px] h-[40px] rounded-l-full rounded-r-none' />
                            <button className=' bg-tripstore-black text-white h-[40px] rounded-l-none rounded-r-full' type="submit">Search</button>
                        </form>
                    </div>
                    <div className=" flex items-center gap-8">
                        <div onClick={toggleShowSearch} className=" hover:text-tripstore-gold cursor-pointer md:hidden"><FaSearch /></div>
                        <div className=" relative">
                            <div onClick={toggleShowAccountDropDown} className=" flex items-center gap-2 font-semibold hover:text-tripstore-gold cursor-pointer">
                                <IoPersonOutline />
                                <span className=' hidden sm:block'>Account</span>
                                <div className={`${showAccountDropDown ? ' rotate-180' : ' rotate-0'} transition`}><FaAngleDown /></div>
                            </div>
                            {
                                showAccountDropDown &&
                                <div className=" absolute z-20 right-0 mt-2 min-w-[200px] rounded-md bg-white shadow-lg border-2 border-slate-300">
                                    <Link to={'/user/dashboard'}>
                                        <div className=" py-2 px-4 hover:bg-slate-300 flex items-center gap-2"><FiLogIn /><span>SIGN IN</span></div>
                                    </Link>
                                    <Link to={'/user/dashboard'}>
                                        <div className=" py-2 px-4 hover:bg-slate-300 flex items-center gap-2"><BsBox2 /><span>Orders</span></div>
                                    </Link>
                                    <Link to={'/user/dashboard'}>
                                        <div className=" py-2 px-4 hover:bg-slate-300 flex items-center gap-2"><FaRegHeart /><span>Saved Items</span></div>
                                    </Link>
                                </div>
                            }
                        </div>
                        <div className=" flex items-center gap-2 font-semibold hover:text-tripstore-gold cursor-pointer">
                            <FiShoppingCart />
                            <span className=' hidden sm:block'>Cart</span>
                        </div>
                    </div>
                </div>
            </div>
            {showAccountDropDown && <div onClick={toggleShowAccountDropDown} className=" absolute z-10 top-0 left-0 w-full h-full bg-black/10"></div>}
            {showSearch && <div onClick={toggleShowSearch} className=" absolute z-10 top-0 left-0 w-full h-full bg-black/10"></div>}
        </>
    )
}

export default Top